import { Badge, BadgeProps, CircularProgress, Tooltip } from '@mui/material';
import React, { ReactElement } from 'react';

interface StudyHeaderActionBadgeProps {
  children: ReactElement;
  color?: BadgeProps['color'];
  count: number;
  countAriaLabel: string;
  countTooltip?: string;
  isLoading: boolean;
  loadingAriaLabel: string;
}

const StudyHeaderActionBadge = ({
  children,
  color = 'primary',
  count,
  countAriaLabel,
  countTooltip,
  isLoading,
  loadingAriaLabel,
}: StudyHeaderActionBadgeProps) => (
  <Badge
    badgeContent={
      isLoading ? (
        <CircularProgress size={12} color="inherit" aria-label={loadingAriaLabel} />
      ) : count > 0 ? (
        countTooltip ? (
          <Tooltip title={countTooltip} placement="top" arrow describeChild>
            <span aria-label={countAriaLabel}>{count}</span>
          </Tooltip>
        ) : (
          <span aria-label={countAriaLabel}>{count}</span>
        )
      ) : null
    }
    color={color}
    max={999}
    sx={{
      '& .MuiBadge-badge': {
        border: 2,
        borderColor: 'background.paper',
        boxSizing: 'border-box',
        height: 22,
        minWidth: 22,
        px: 0.5,
        right: 2,
        top: 2,
      },
    }}
  >
    {children}
  </Badge>
);

export default StudyHeaderActionBadge;
